
<ui-detail-view-container>
    <ui-detail-section>
        <ui-detail-image
            [imagePath]="offering().imagePath"
            [altText]="offering().title"
        />

        <ui-detail-title [title]="offering().title"/>

        <ui-detail-address [text]="offering().address"/>

        <ui-detail-tags
            [tags]="['Kulturangebot']"
        />
    </ui-detail-section>

    @if (offering().cultureCategories; as cultureCategories) {
        <ui-detail-tags
            [title]="'Kulturkategorien'"
            [tags]="cultureCategories"
        />
    }

    @if (offering().shortDescription; as shortDescription) {
        <ui-detail-description
            [title]="'Kultursparte'"
            [htmlDescription]="shortDescription"
        />
    }

    @if (offering().linkedItems?.length) {
        <ui-detail-table titleLeft="Kulturinstitution oder -location">
            @for (linkedItem of offering().linkedItems; track linkedItem.id) {
                <ui-detail-table-row>
                    <ng-container left>
                        <ui-detail-link
                            [label]="linkedItem.title"
                            (mapItemLinkClicked)="triggerMapItemById(linkedItem)"
                        />

                        <ui-detail-description
                            [htmlDescription]="linkedItem.address.join('<br/>')"
                        />
                    </ng-container>
                </ui-detail-table-row>
            }
        </ui-detail-table>
    }

    @if (targetGroups().length; as length) {
        <ui-detail-tags
            [title]="length > 1 ? 'Zielgruppen' : 'Zielgruppe'"
            [tags]="targetGroups()"
        />
    }

    @if (cultureExperienceTypes().length; as length) {
        <ui-detail-tags
            [title]="length > 1 ? 'Arten des Erlebnisses' : 'Art des Erlebnisses'"
            [tags]="cultureExperienceTypes()"
        />
    }

    @if (offering().cultureUsageType; as cultureUsageType) {
        <ui-detail-tags
            [title]="'Art der Nutzung'"
            [tags]="[cultureUsageType]"
        />
    }

    @if (offering().languages; as languages) {
        <ui-detail-description
            [title]="'Sprachen'"
            [htmlDescription]="languages"
        />
    }

    @if (offering().offerPeriod; as offerPeriod) {
        <ui-detail-description
            [title]="'Angebotszeitraum'"
            [htmlDescription]="offerPeriod"
        />
    }

    @if (offering().openingHours; as openingHours) {
        <ui-detail-description
            [title]="'Öffnungszeiten'"
            [htmlDescription]="openingHours"
        />
    }

    @if (offering().contact; as contact) {
        <ui-detail-contact
            [title]="'Ansprechperson'"
            [contact]="contact"
        />
    }

    @if (offering().accessibilityFeatures; as accessibilityFeatures) {
        <ui-detail-section [title]="'Zugangsmöglichkeiten'">
            <ui-detail-boolean
                [title]="'Barrierefreier Zugang'"
                [value]="accessibilityFeatures.locationAccess"
            />
            <ui-detail-description
                [title]="'Aufzug Zugangsmöglichkeit'"
                [htmlDescription]="accessibilityFeatures.elevatorAccess + ''"
            />
            <ui-detail-boolean
                [title]="'Barrierefreie Toiletten'"
                [value]="accessibilityFeatures.toiletAccess"
            />
            <ui-detail-boolean
                [title]="'Pflegeliege in Toiletten'"
                [value]="accessibilityFeatures.toiletNursingBed"
            />
            <ui-detail-boolean
                [title]="'Induktionsschleife'"
                [value]="accessibilityFeatures.inductionLoop"
            />
            <ui-detail-boolean
                [title]="'Audiodeskription'"
                [value]="accessibilityFeatures.audioDescription"
            />
            <ui-detail-boolean
                [title]="'Audioguide'"
                [value]="accessibilityFeatures.audioGuide"
            />
            <ui-detail-boolean
                [title]="'Blindenleitsystem'"
                [value]="accessibilityFeatures.blindGuidanceSystem"
            />
            <ui-detail-boolean
                [title]="'Andere Orientierungshilfen'"
                [value]="accessibilityFeatures.otherOrientationAids"
            />
            <ui-detail-description
                [title]="'Dolmetscher Zugangsmöglichkeit'"
                [htmlDescription]="accessibilityFeatures.interpreterAccess + ''"
            />
            <ui-detail-boolean
                [title]="'Informationsmaterial in leichter Sprache'"
                [value]="accessibilityFeatures.informationMaterialSimpleLanguage"
            />
            <ui-detail-boolean
                [title]="'Website in leichter Sprache'"
                [value]="accessibilityFeatures.websiteSimpleLanguage"
            />

            @if (accessibilityFeatures.inclusionContact; as inclusionContact) {
                <ui-detail-contact
                    class="mt-l"
                    [title]="'Ansprechperson für Inklusion'"
                    [contact]="inclusionContact"
                />
            }
        </ui-detail-section>
    }
</ui-detail-view-container>
